export const NO_HEADER_ROUTES = [
  'auth',
  'changepswd',
  'forgot',
  'pdf-preview',
  'physician/sso-forward',
  // Patient-facing research consent: matches both the SPA route
  // (`/research-consent?token=…`) and the unauthenticated API it calls
  // (`api/public/research-consent/…`).
  //
  // These entries are matched with `url.includes(...)` against BOTH router URLs
  // and outgoing request URLs, so anything caught here is treated as needing no
  // auth. The staff-facing consent endpoints therefore live under
  // `api/consent-requests`, clear of this substring — naming one of them
  // `…/research-consent` would silently drop it out of the auth interceptor's
  // token-refresh handling.
  'research-consent',
  'swagger'
]


export const APP_TIMEOUT_MINUTES = 12;

// How often to proactively refresh the access/refresh tokens while the session
// backend refresh-token TTL..
export const TOKEN_REFRESH_INTERVAL_MINUTES = 10;

const height = {
  CM: {
    MIN: 50,
    MAX: 272,
  },
  IN: {
    MIN: { feet: 1, inches: 6 }, // 1'6"
    MAX: { feet: 8, inches: 9 }, // 8'9"
  },
};

const neckSize = {
  CM: { MIN: 25, MAX: 51 }, // 10–20 in
  IN: { MIN: 10, MAX: 20 }, // inches (single value, not feet/inches)
};

const weight = {
  KG: { MIN: 10, MAX: 300 },
  LB: { MIN: 22, MAX: 660 },
};



export const PATIENT_LIMITS = {
  height,
  neckSize,
  weight
}
